<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card asset-restriction-approval-page">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-card-tabs [tabitems]="tabitems"></app-card-tabs>
          </div>
          <div class="col-md-10">
            <div *ngIf="asset && workflowItem" class="asset-restriction-approval-content mb-2 animated fadeIn">
              <div class="asset-restriction-approval-title">
                <i class="far fa-edit"></i>
                <h3 class="mb-0">{{ pageTitle }}</h3>
              </div>

              <div class="asset-restriction-approval-meta">
                <h4 class="asset-restriction-approval-name asset-restriction-approval-name--site mb-2">Site: <strong>{{ asset.site.name }}</strong></h4>
                <h5 class="asset-restriction-approval-name asset-restriction-approval-name--asset mb-0">
                  Asset:
                  <strong>{{ asset.name }} - {{ asset.description }}</strong>
                </h5>
              </div>

              <div class="asset-restriction-approval-badges">
                <i *ngIf="!asset.locked" class="fas fa-unlock color_green-shade1"></i>
                <i *ngIf="asset.locked" class="fas fa-lock color_red-shade1"></i>
                <ng-container *ngFor="let category of asset.assetCategories">
                  <span class="badge badge-pill badge-primary" [ngStyle]="{ 'background-color': category.color }">{{category.name}}</span>
                </ng-container>
              </div>

              <div class="asset-restriction-approval-details">
                <h6>Details</h6>
                <p class="mb-2">
                  On <b>{{ workflowItem.createdDate | date: 'E d MMM yyyy' }}</b> user
                  <username-display [userName]="workflowItem.createdBy"></username-display>
                  raised the following change to the restrictions:
                </p>

                <p class="asset-restriction asset-restriction--approval">{{ workflowItem.restrictions }}</p>

                <p *ngIf="workflowItem.lockAsset" class="asset-restriction-approval-lock-note">
                  <i class="fas fa-lock color_red-shade1"></i>
                  They suggest locking the asset until it can be resolved.
                </p>
              </div>

              <div class="asset-restriction-approval-actions" *ngIf="!showRestrictionForm && !showRejectionForm && !isViewOnly">
                <button type="submit" class="btn btn-success btn-round btn-round-action" [disabled]="saveInProgress" (click)="approve()">Approve</button>
                <button type="submit" class="btn btn-danger btn-round btn-round-action" [disabled]="saveInProgress" (click)="reject()">Reject</button>
              </div>

              <ng-container *ngIf="showRejectionForm && !isViewOnly">
                <div class="asset-restriction-approval-form-intro alert alert-warning" role="alert">
                  <p class="mb-0"><b>Let the requester know why this was rejected</b></p>
                </div>

                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Comment <span class="required-text">(required)</span></label>
                      <!-- maxlength matches workflow_item.comments (varchar 350), so an over-long
                           comment is stopped here rather than by a 500 from the API -->
                      <textarea
                        type="text"
                        class="form-control asset-restriction-textarea"
                        placeholder="Enter reason for rejecting this restriction..."
                        maxlength="350"
                        [(ngModel)]="rejectionForm"></textarea>
                      <small class="form-text text-muted text-right">350 characters maximum</small>
                    </div>
                  </div>
                </div>
                <div class="asset-restriction-approval-actions">
                  <button type="submit" class="btn btn-success btn-round btn-round-action" [disabled]="saveInProgress || !rejectionForm.trim()" (click)="saveRejection()">Reject</button>
                  <button type="button" class="btn btn-link btn-link-cancel" [disabled]="saveInProgress" (click)="cancelRejection()">
                    <i class="fas fa-times"></i>
                    Cancel
                  </button>
                </div>
              </ng-container>

              <ng-container *ngIf="showRestrictionForm">
                <div class="asset-restriction-approval-form-intro alert alert-warning" role="alert">
                  <p class="mb-0"><b>Finalise the restrictions below and save</b></p>
                  <p class="mb-0">Review the restriction details carefully before approving, because this will update the asset immediately.</p>
                </div>

                <form [formGroup]="approveRestrictionForm" (ngSubmit)="save()">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Restriction Description<span class="required-star"> *</span></label>
                        <textarea type="text" class="form-control asset-restriction-textarea" formControlName="description"></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label>Type<span class="required-star"> *</span></label>
                        <p-dropdown
                          class="form-control asset-restriction-dropdown"
                          formControlName="type"
                          [options]="restrictionTypes"
                          optionLabel="label"
                          placeholder="Select Restriction type..">
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group asset-restriction-lock-control">
                        <label>Lock Asset</label>
                        <div>
                          <p-inputSwitch formControlName="lockAsset"></p-inputSwitch>
                        </div>
                        <p *ngIf="asset.locked" class="asset-restriction-lock-warning">
                          <i class="fas fa-exclamation-triangle"></i>
                          This option is not available, the asset is currently locked
                        </p>
                      </div>
                    </div>
                  </div>
                </form>

                <div class="asset-restriction-approval-actions">
                  <button type="submit" class="btn btn-success btn-round btn-round-action" [disabled]="saveInProgress || !approveRestrictionForm.valid" (click)="save()">Save Changes</button>
                  <button type="button" class="btn btn-link btn-link-cancel" [disabled]="saveInProgress" (click)="cancelApprovalForm()">
                    <i class="fas fa-times"></i>
                    Cancel
                  </button>
                </div>
              </ng-container>

              <div class="asset-restriction-approval-table-section">
                <h6>Current asset restrictions:</h6>
                <p-table [value]="asset.restrictions" [autoLayout]="true" class="asset-restriction-approval-table">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width:50%">Restriction Description</th>
                      <th>Type</th>
                      <th>Created By</th>
                      <th>Created Date</th>
                      <th>Last Modified By</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-restriction>
                    <tr>
                      <td><p class="asset-restriction"><i class="fas fa-exclamation-triangle"></i>&nbsp;{{ restriction.description }}</p></td>
                      <td>
                        <span *ngIf="restriction.type === 'OPERATIONAL'" class="badge badge-pill badge-warning">Operational</span>
                        <span *ngIf="restriction.type === 'HEALTH_AND_SAFETY'" class="badge badge-pill badge-danger">Health & Safety</span>
                        <span *ngIf="restriction.type === 'GENERAL'" class="badge badge-pill badge-primary">General</span>
                      </td>
                      <td>{{ restriction.createdBy }}</td>
                      <td><date-friendly [value]="restriction.createdDate"></date-friendly></td>
                      <td>{{ restriction.lastModifiedBy }}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="5">No restrictions found</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
